<div class="dashboards">
  <div *ngFor="let gitlab of gitlabInstances">
    <app-dashboard [gitlabInstanceName]="gitlab"></app-dashboard>
  </div>
</div>
